// ListeningIndicator.js
import React from "react";

export default function ListeningIndicator({ style, text = "Listening..." }) {
    return (
        <div className="listening-indicator" style={style}>
            <span className="dot"></span>
            <span className="label">{text}</span>
        </div>
    );
}